import api from '@/services/utils/apiInstance'

class EstimateRepairerService {
  async backToRepairerOffersCreation(repair_file_id) {
    const data = {
      repair_file_id: repair_file_id
    }
    const response = await api.put('/admin/repair-file/repairer-estimate/back-to-creation', data)
    return response.data
  }

  async createRepairFileRepairerEstimate(data) {
    const response = await api.post('/admin/repair-file/repairer-estimate/create', data)
    return response.data
  }

  async updateRepairFileRepairerEstimate(data) {
    const response = await api.put('/admin/repair-file/repairer-estimate/update', data)
    return response.data
  }

  async createRepairFileRepairerEstimateOption(data) {
    const response = await api.post('/admin/repair-file/repairer-estimate-option/create', data)
    return response.data
  }

  async updateRepairFileRepairerEstimateOption(data) {
    const response = await api.put('/admin/repair-file/repairer-estimate-option/update', data)
    return response.data
  }

  async deleteRepairFileRepairerEstimateOption(data) {
    const response = await api.post('/admin/repair-file/repairer-estimate-option/delete', data)
    return response.data
  }

  async confirmationRepairFileRepairerEstimate(data) {
    const response = await api.put('/admin/repair-file/repairer-estimate/confirmation', data)
    return response.data
  }

  async sendRepairFileRepairerEstimateToClient(data) {
    const response = await api.post('/admin/repair-file/send-email-repairer-estimate', data)
    return response.data
  }

  async sendNewRepairFileRepairerEstimateToClient(data) {
    const response = await api.post('/admin/repair-file/send-new-email-repairer-estimate', data)
    return response.data
  }

  async saveRepairerEstimateOptionClientChoiceFromManualSelection(data) {
    const response = await api.post(
      '/admin/repair-file/repairer-estimate/manual-selection-choice',
      data
    )
    return response.data
  }
}

export default new EstimateRepairerService()
